import React from 'react';

type AuthBaseFormProps = { title: string; children: React.ReactNode };

function AuthBaseForm({ title, children }: AuthBaseFormProps) {
  return (
    <div className='flex flex-col gap-12 items-center md:items-start p-3 md:p-0 w-full md:w-[400px]'>
      <div className='bg-brand-third border-solid border-brand-primary-border flex flex-col justify-between w-full items-start pb-4 p-4 sm:p-7 border rounded-lg'>
        <div className='flex flex-col m-px gap-6 w-full items-start flex-1'>
          <div className='text-xl font-semibold tracking-[0.88] text-white text-center w-full flex justify-center items-center capitalize'>
            Login/Signup
          </div>
          <div className='w-full flex flex-col gap-4'>{children}</div>
        </div>
      </div>
    </div>
  );
}

export default AuthBaseForm;
